import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  progressBar: 0,
  isWlcmOfferClaimed: false,
  howItWorksToggle: false,
  prevBrandToggle: false,
  ERPSyncStatus: 0,
  selectedSlot: "",
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setProgressBar: (state, action) => ({
      ...state,
      progressBar: action.payload,
    }),
    handleWelcomerOffer: (state, action) => ({
      ...state,
      isWlcmOfferClaimed: action.payload,
    }),
    handleHowItWorksToggle: (state) => ({
      ...state,
      howItWorksToggle: !state.howItWorksToggle,
    }),
    setHowItWorksToggleFalse: (state) => ({
      ...state,
      howItWorksToggle: false,
    }),
    handlePrevBrandToggle: (state) => ({
      ...state,
      prevBrandToggle: !state.prevBrandToggle,
    }),
    setprevBrandToggleFalse: (state) => ({
      ...state,
      prevBrandToggle: false,
    }),
    setTimeSlot: (state, action) => ({
      ...state,
      selectedSlot: action.payload,
    }),
    setERPSyncStatus: (state, action) => ({
      ...state,
      ERPSyncStatus: action.payload,
    }),
  },
});

export const {
  setProgressBar,
  handleWelcomerOffer,
  handleHowItWorksToggle,
  setHowItWorksToggleFalse,
  handlePrevBrandToggle,
  setprevBrandToggleFalse,
  setTimeSlot,
  setERPSyncStatus,
} = homeSlice.actions;
export default homeSlice;
